import React from 'react';

import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 2rem;
`;

const Number = styled.div`
    color: ${(props) => props.theme.colors.primary.main};
    font-size: 24px;
`;

const Label = styled.div`
    ${(props) => props.theme.colors.text.secondary};
`;

export interface AttendanceMetricProps {
    count: number;
    label: string;
    id: string;
}

const AttendanceMetric: React.FC<AttendanceMetricProps> = ({ count, label, id }) => (
    <Container id={id}>
        <Number data-testid="value">{count}</Number>
        <Label data-testid="label">{label}</Label>
    </Container>
);

export default AttendanceMetric;
